import { render, staticRenderFns } from "./SalaryRatio.vue?vue&type=template&id=6ebb4745"
import script from "./SalaryRatio.vue?vue&type=script&lang=js"
export * from "./SalaryRatio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports